<template>
  <section class="chess-controls">
    <button 
      v-if="isPaused"
      title="Information"
      @click="$emit('info')"
    >
    <span class="visually-hidden">information</span>
    <svg viewBox="0 0 18 18">
      <path d="M6 6.96118C6.0166 5.0228 7.5715 3.4679 9.50988 3.4513C11.4817 3.43442 13.0804 5.04987 13.0804 7.0218C13.0804 9.96275 9.06059 9.79233 9.06059 11.6706M9.06059 14.9926V14.7414"/>
    </svg>

    </button>
    <button v-if="gameStarted" @click="$emit('togglePause')">
      <template v-if="isPaused">
        <span class="visually-hidden">play</span>
        
        <svg viewBox="0 0 18 18">
          <path d="M13.1198 9.04805L5.06618 15.0508L5.06618 3.0453L13.1198 9.04805Z" />
        </svg>

      </template>
      <template v-else>
        <span class="visually-hidden">pause</span>
        
        <svg viewBox="0 0 18 18">
          <path d="M13 4L13 14" />
          <path d="M5 4L5 14" />
        </svg>

      </template>
    </button>
    <template v-if="isPaused">
      <button v-if="gameStarted" @click="$emit('stop')">
        <span class="visually-hidden">Get Notation</span>
        <svg viewBox="0 0 18 18" fill="none">
          <path d="M6.5 3.5L4 3.5C3.44772 3.5 3 3.94772 3 4.5L3 15C3 15.5523 3.44772 16 4 16H14C14.5523 16 15 15.5523 15 15V4.5C15 3.94772 14.5523 3.5 14 3.5L11 3.5" stroke="#FFFBEC" stroke-width="2"/>
          <line x1="6" y1="9.5" x2="12" y2="9.5" stroke="#FFFBEC"/>
          <line x1="6" y1="12.5" x2="12" y2="12.5" stroke="#FFFBEC"/>
          <path d="M9 2C10.0191 2 10.6851 2.53026 11 2.85943V5.5H7L7 2.85943C7.31487 2.53026 7.98094 2 9 2Z" stroke="#FFFBEC" stroke-width="2"/>
        </svg>


      </button>
      <button 
        v-else 
        title="New Clock Settings"
        @click="$emit('settings')"
      >
      <svg viewBox="0 0 18 18">
        <path d="M3.04865 5L14.9514 5" />
        <path d="M3.04865 13L14.9514 13" />
        <circle cx="11.5354" cy="4.96649" r="1.30841" />
        <circle cx="6.40942" cy="13.012" r="1.30841" />
      </svg>

      </button>
    
    </template>
  </section>
</template>

<script>
  export default {
    name: 'ChessControls',
    props: {
      isPaused: {
        type: Boolean,
        default: false
      },
      gameStarted: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>
.chess-controls {
  display: flex;
}

.chess-controls button {
  border: 0;
  background: var(--magic);
  width: 100%;
  font-size: 30px;
}
</style>